import { MockedRequest, RestHandler, rest } from "msw";

import { MOCK_BODYSHOPS_BY_POSTCODE } from "mocks/fixtures/bodyShopsByPostalCode";
import { DigitalJourneyBodyShop } from "types/DigitalJourneySession";
import { ErrorResponse } from "types/ErrorResponse";

export const getBodyShopsByPostCodeHandler = (
  status: number,
  response: Array<DigitalJourneyBodyShop> | ErrorResponse
): RestHandler<MockedRequest<Array<DigitalJourneyBodyShop> | ErrorResponse>> => {
  return rest.get(`/session/digitalJourney/bodyShops`, (_, res, ctx) => {
    return res(ctx.status(status), ctx.json(response));
  });
};

export const bodyShopsByPostCodeHandler = [getBodyShopsByPostCodeHandler(200, MOCK_BODYSHOPS_BY_POSTCODE)];
